import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchOrificeSizes, createOrificeSize, deleteOrificeSize, updateOrificeSize } from '../../common/jsonstore';
import { OrificeSize } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError, handleSuccess } from '../../services/messageApiService';


const initialState: OrificeSize[] = []; //model interface

const OrificeSizeSlice = createSlice({
  name: 'OrificeSizes',
  initialState,
  reducers: {
    receiveOrificeSizes(state, action: PayloadAction<OrificeSize[]>) {
      return action.payload;
    },
    receiveOrificeSize(state, action: PayloadAction<OrificeSize>) {
      state.push(action.payload);
    },
  }
});

// export const { toggleOrificeSize } = OrificeSizeSlice.actions;

export const loadOrificeSizes = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const OrificeSizes = await fetchOrificeSizes().then((res: any) => {
      dispatch(OrificeSizeSlice.actions.receiveOrificeSizes(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Size not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export const addOrificeSize = (newOrificeSize: OrificeSize): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await createOrificeSize(newOrificeSize).then((res: any) => {
      dispatch(OrificeSizeSlice.actions.receiveOrificeSize(res));
      handleSuccess('Orifice Size added successfully');
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Size not added';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export const modifyOrificeSize = (newOrificeSize: OrificeSize, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await updateOrificeSize(newOrificeSize, id).then((res: any) => {
      const updatedOrificeSizes = getState().OrificeSizes.map(el => (el.id === id ? res : el))
      dispatch(OrificeSizeSlice.actions.receiveOrificeSizes(updatedOrificeSizes));
      handleSuccess('Orifice Size updated successfully')
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Size not updated';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export const removeOrificeSize = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteOrificeSize(id).then((res: any) => {
      const updatedOrificeSizes = getState().OrificeSizes.filter((item) => item.id !== id);
      dispatch(OrificeSizeSlice.actions.receiveOrificeSizes(updatedOrificeSizes));
      handleSuccess('Orifice Size deleted successfully')
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Orifice Size not deleted';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }

}

export default OrificeSizeSlice.reducer;
